<template>
  <!-- eslint-disable -->
  <div>
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <TopNav />

      <div v-if="loading" class="loading-container">
        <Loader :width="100" :height="100" />
      </div>

      <div v-else class="medical-calendar-container">
        <!-- Header Section -->
        <div class="calendar-header-section">
          <div class="header-content">
            <div class="title-section">
              <div class="calendar-icon" :style="{
                background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                  ? `linear-gradient(135deg, ${prestador.admin.assets.colors.primary}, ${prestador.admin.assets.colors.secondary})`
                  : 'linear-gradient(135deg, #3b82f6, #1d4ed8)'
              }">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div class="title-text">
                <h1 class="calendar-title">Calendario de Atenciones</h1>
                <p class="calendar-subtitle">Gestión de citas y servicios domiciliarios</p>
              </div>
            </div>

            <div class="view-controls">

              <!-- Prestadores -->
              <div style="position: relative;">
                <button v-if="prestador.id == 1" @click="showDropdownPrestador = !showDropdownPrestador" type="button"
                  class="btn btn-outline-primary">
                  Prestadores ({{ selectedPrestador.length || 'Todos' }})
                </button>
                <div v-if="showDropdownPrestador" class="dropdown-menu"
                  style="display: block; max-height: 200px; overflow-y: auto; position: absolute; z-index: 100;">
                  <label style="display: block; padding: 5px;">
                    <input type="checkbox" value="" @change="selectedPrestador = []"
                      :checked="selectedPrestador.length === 0" />
                    Todos
                  </label>
                  <label v-for="prest in prestadores" :key="prest.id" style="display: block; padding: 5px;">
                    <input type="checkbox" :value="prest.nombre" v-model="selectedPrestador" />
                    {{ prest.nombre }}
                  </label>
                </div>
              </div>

              <!-- Profesionales -->
              <div style="position: relative;">
                <button @click="showDropdownProfesional = !showDropdownProfesional" type="button"
                  class="btn btn-outline-primary">
                  Profesionales ({{ selectedProfesional.length || 'Todos' }})
                </button>
                <div v-if="showDropdownProfesional" class="dropdown-menu"
                  style="display: block; max-height: 300px; overflow-y: auto; position: absolute; z-index: 100; min-width: 250px;">
                  <input type="text" v-model="profesionalSearch" placeholder="Buscar profesional"
                    style="width: 90%; margin: 5px;" />
                  <label style="display: block; padding: 5px;">
                    <input type="checkbox" value="" @change="selectedProfesional = []"
                      :checked="selectedProfesional.length === 0" />
                    Todos
                  </label>
                  <label v-for="prof in filteredProfesionales" :key="prof.id" style="display: block; padding: 5px;">
                    <input type="checkbox" :value="prof.id" v-model="selectedProfesional" />
                    {{ prof.nombre }} {{ prof.apellido }}
                  </label>
                </div>
              </div>

              <!-- Estados -->
              <div style="position: relative;">
                <button @click="showDropdownStatus = !showDropdownStatus" type="button" class="btn btn-outline-primary">
                  Estados ({{ selectedStatus.length || 'Todos' }})
                </button>
                <div v-if="showDropdownStatus" class="dropdown-menu"
                  style="display: block; max-height: 150px; overflow-y: auto; position: absolute; z-index: 100;">
                  <label v-for="(label, key) in status[0]" :key="key" style="display: block; padding: 5px;">
                    <input type="checkbox" :value="String(key)" v-model="selectedStatus" />
                    {{ label }}
                  </label>
                </div>
              </div>

              <button @click="applyFilters()" class="btn" :style="{
                color: 'white',
                backgroundColor: prestador.admin.assets.colors.primary,
                borderColor: prestador.admin.assets.colors.primary
              }">
                Aplicar Filtros
              </button>
            </div>

            <div class="view-controls">
              <button class="view-btn" :class="{ 'active': view === 'day' }" @click="changeView('day')" :style="view === 'day' && prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                ? {
                  color: 'white',
                  backgroundColor: prestador.admin.assets.colors.primary,
                  borderColor: prestador.admin.assets.colors.primary
                } : {}">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                Día
              </button>
              <button class="view-btn" :class="{ 'active': view === 'week' }" @click="changeView('week')" :style="view === 'week' && prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                ? {
                  color: 'white',
                  backgroundColor: prestador.admin.assets.colors.primary,
                  borderColor: prestador.admin.assets.colors.primary
                } : {}">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                  <line x1="7" y1="14" x2="17" y2="14"></line>
                </svg>
                Semana
              </button>
              <button class="view-btn" :class="{ 'active': view === 'month' }" @click="changeView('month')" :style="view === 'month' && prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                ? {
                  color: 'white',
                  backgroundColor: prestador.admin.assets.colors.primary,
                  borderColor: prestador.admin.assets.colors.primary
                } : {}">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                  <line x1="7" y1="14" x2="17" y2="14"></line>
                  <line x1="7" y1="18" x2="17" y2="18"></line>
                </svg>
                Mes
              </button>
            </div>
          </div>

          <!-- Navigation Section -->
          <!-- Navigation Section - QUITA v-if PARA MOSTRAR EN TODAS LAS VISTAS -->
          <div class="navigation-section">
            <button @click="navigatePrevious" class="nav-btn" :style="{
              borderColor: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                ? prestador.admin.assets.colors.primary + '40' : '#3b82f640'
            }">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M15 18l-6-6 6-6"></path>
              </svg>
            </button>

            <h2 class="current-period">{{ currentPeriodText }}</h2>

            <button @click="navigateNext" class="nav-btn" :style="{
              borderColor: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                ? prestador.admin.assets.colors.primary + '40' : '#3b82f640'
            }">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 18l6-6-6-6"></path>
              </svg>
            </button>
          </div>

          <!-- Status Legend -->
          <div class="status-legend">
            <h4 class="legend-title">Estado de las Citas</h4>
            <div class="legend-items">
              <div class="legend-item">
                <div class="legend-color cancelled"></div>
                <span>Anulado</span>
              </div>
              <div class="legend-item">
                <div class="legend-color scheduled"></div>
                <span>Citado</span>
              </div>
              <div class="legend-item">
                <div class="legend-color confirmed"></div>
                <span>Confirmado</span>
              </div>
              <div class="legend-item">
                <div class="legend-color in-progress"></div>
                <span>Atendido</span>
              </div>
              <div class="legend-item">
                <div class="legend-color completed"></div>
                <span>No Atendido</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Vista de día -->
        <div v-if="view === 'day'" class="day-view">
          <div class="day-header" :style="{
            background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
              ? `linear-gradient(135deg, ${prestador.admin.assets.colors.primary}, ${prestador.admin.assets.colors.secondary})`
              : 'linear-gradient(135deg, #3b82f6, #1d4ed8)'
          }">
            <div class="day-info">
              <h3 class="day-title">{{ currentDayText }}</h3>
              <p class="day-subtitle">Vista detallada del día</p>
            </div>
          </div>

          <div class="timeline-container">
            <div v-for="hour in extendedHours" :key="hour" class="hour-block"
              style="position: relative; min-height: 80px;">
              <div class="hour-indicator">
                <div class="hour-time">{{ hour }}:00</div>
                <div class="hour-line"></div>
              </div>

              <div class="appointments-column" style="position: relative; height: 100%; min-height: 80px;">
                <!-- Contenedor para citas de la misma hora -->
                <div class="same-hour-appointments" v-if="getOrdersForHour(hour).length > 0">
                  <div v-for="order in getOrdersForHour(hour)" :key="order.id" class="appointment-card notion-card"
                    :class="getOrderStatusClass(order)" @click="showOrderDetails(order)">
                    <div class="appointment-header">
                      <div class="appointment-time" :style="{
                        color: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                          ? prestador.admin.assets.colors.primary : '#3b82f6'
                      }">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12,6 12,12 16,14"></polyline>
                        </svg>
                        {{ formatTime(order.desde) }} - {{ formatTime(order.hasta) }}
                      </div>
                      <span class="status-badge" :class="getStatusBadgeClass(order)">
                        {{ getStatusText(order.estado) }}
                      </span>
                    </div>

                    <div class="appointment-content">
                      <div class="patient-info">
                        <div class="patient-avatar" :style="{
                          background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                            ? `linear-gradient(135deg, ${prestador.admin.assets.colors.primary}, ${prestador.admin.assets.colors.secondary})`
                            : 'linear-gradient(135deg, #3b82f6, #1d4ed8)'
                        }">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                            <circle cx="12" cy="7" r="4"></circle>
                          </svg>
                        </div>
                        <div class="patient-details">
                          <div class="patient-name">{{ order.nombre }} {{ order.apellido1 }}</div>
                          <div class="patient-meta">Paciente</div>
                        </div>
                      </div>

                      <div class="service-info">
                        <div class="service-icon" :style="{
                          color: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                            ? prestador.admin.assets.colors.primary : '#3b82f6'
                        }">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                          </svg>
                        </div>
                        <span class="service-name">{{ getServiceName(order) }}</span>
                      </div>

                      <div class="professional-info">
                        <div class="professional-icon" :style="{
                          color: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                            ? prestador.admin.assets.colors.primary : '#3b82f6'
                        }">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="8.5" cy="7" r="4"></circle>
                            <path d="M20 8v6"></path>
                            <path d="M23 11h-6"></path>
                          </svg>
                        </div>
                        <span class="professional-name">Prof. {{ getProfessionalName(order) }}</span>
                      </div>

                      <div class="location-info">
                        <div class="location-icon" :style="{
                          color: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                            ? prestador.admin.assets.colors.primary : '#3b82f6'
                        }">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                          </svg>
                        </div>
                        <span class="location-text">{{ order.direccion || 'Sin dirección' }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Mensaje de hora vacía CON BOTÓN -->
                <div v-else class="empty-hour"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center; width: 100%;">
                  <div class="empty-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
                      <circle cx="12" cy="12" r="10"></circle>
                    </svg>
                  </div>
                  <span class="empty-text" style="display: block; margin-bottom: 10px;">Sin citas programadas</span>

                  <!-- BOTÓN PARA AGREGAR CITA EN VISTA DÍA -->
                  <button class="add-appointment-btn" @click.stop="openAgendaModalForDay(hour)"
                    v-if="false" :style="{
                      background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                        ? prestador.admin.assets.colors.primary : '#3b82f6',
                      marginTop: '10px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '5px',
                      padding: '8px 12px',
                      borderRadius: '6px',
                      color: 'white',
                      border: 'none',
                      cursor: 'pointer'
                    }">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <line x1="12" y1="5" x2="12" y2="19"></line>
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    Agregar Cita
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Vista de semana -->
        <div v-if="view === 'week'" class="week-view-v3">
          <div class="week-header" :style="{
            background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
              ? `linear-gradient(135deg, ${prestador.admin.assets.colors.primary}, ${prestador.admin.assets.colors.secondary})`
              : 'linear-gradient(135deg, #3b82f6, #1d4ed8)'
          }">
            <div class="week-info">
              <h3 class="week-title">Vista Semanal</h3>
              <p class="week-subtitle">{{ currentWeekText }}</p>
            </div>
          </div>

          <!-- Week Calendar Container -->
          <div class="week-calendar-container">
            <!-- Fixed Header -->
            <div class="week-fixed-header">
              <div class="week-time-column-header">
                <div class="time-header-content">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12,6 12,12 16,14"></polyline>
                  </svg>
                  Hora
                </div>
              </div>
              <div class="week-days-header">
                <div v-for="day in weekDays" :key="day.date" class="week-day-header-cell"
                  :class="{ 'today': isToday(day.fullDate) }" :style="isToday(day.fullDate) ? {
                    background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                      ? `linear-gradient(135deg, ${prestador.admin.assets.colors.primary}, ${prestador.admin.assets.colors.secondary})`
                      : 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                    color: 'white'
                  } : {}">
                  <div class="day-name">{{ day.name }}</div>
                  <div class="day-date">{{ day.date }}</div>
                  <div class="day-month">{{ getMonthName(day.fullDate) }}</div>
                </div>
              </div>
            </div>

            <!-- Scrollable Content -->
            <div class="week-scrollable-content">
              <div class="week-time-column">
                <div v-for="hour in extendedHours" :key="hour" class="week-time-slot-v3">
                  <div class="time-slot-content">
                    <span class="hour-number">{{ formatHour(hour) }}</span>
                    <span class="hour-period">{{ getHourPeriod(hour) }}</span>
                  </div>
                </div>
              </div>

              <div class="week-days-grid">
                <div v-for="day in weekDays" :key="day.date" class="week-day-column">
                  <div v-for="hour in extendedHours" :key="hour" class="week-hour-cell-v3" :class="{
                    'today': isToday(day.fullDate),
                    'current-hour': isCurrentHour(day.fullDate, hour),
                    'past-hour': isPastHour(day.fullDate, hour)
                  }" :style="isToday(day.fullDate) ? {
                    backgroundColor: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                      ? prestador.admin.assets.colors.primary + '08' : '#3b82f608'
                  } : {}">

                    <!-- Current time indicator -->
                    <div v-if="isCurrentHour(day.fullDate, hour)" class="current-time-indicator" :style="{
                      background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                        ? prestador.admin.assets.colors.primary : '#3b82f6'
                    }"></div>

                    <!-- Botón para agregar cita en esta celda -->
                    <button class="add-appointment-btn" @click.stop="openAgendaModal(day.fullDate, hour)"
                      v-if="false"
                      :style="{
                        background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                          ? prestador.admin.assets.colors.primary : '#3b82f6'
                      }">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                      </svg>
                    </button>

                    <div class="hour-appointments">
                      <div v-for="order in getOrdersForDayAndHour(day.fullDate, hour)" :key="order.id"
                        class="week-appointment-v3 notion-mini-card" :class="getOrderStatusClass(order)"
                        @click.stop="showOrderDetails(order)" :style="getAppointmentStyle(order)"
                        :title="`${formatTime(order.desde)} - ${formatTime(order.hasta)} | ${order.nombre} ${order.apellido1} | ${getServiceName(order)} | Prof. ${getProfessionalName(order)}`">

                        <div class="appointment-time-badge" :style="{
                          background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                            ? prestador.admin.assets.colors.primary : '#3b82f6'
                        }">
                          {{ formatTime(order.desde) }}
                        </div>

                        <div class="appointment-content-v3">
                          <div class="appointment-patient">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2">
                              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                              <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                            {{ order.nombre.split(' ')[0] }} {{ order.apellido1.split(' ')[0] }}
                          </div>

                          <div class="appointment-service">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2">
                              <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                            </svg>
                            {{ truncateText(getServiceName(order), 25) }}
                          </div>

                          <div class="appointment-professional">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2">
                              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                              <circle cx="8.5" cy="7" r="4"></circle>
                              <path d="M20 8v6"></path>
                              <path d="M23 11h-6"></path>
                            </svg>
                            Prof. {{ getProfessionalName(order).split(' ')[0] }}
                          </div>

                          <div v-if="order.direccion" class="appointment-location">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                              stroke-width="2">
                              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                              <circle cx="12" cy="10" r="3"></circle>
                            </svg>
                            {{ truncateText(order.direccion, 30) }}
                          </div>
                        </div>

                        <div class="appointment-status-indicator" :class="getOrderStatusClass(order)"></div>
                      </div>
                    </div>

                    <div v-if="getOrdersForDayAndHour(day.fullDate, hour).length === 0" class="empty-hour-cell">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Vista de mes -->
        <div v-if="view === 'month'" class="month-view">
          <div class="month-header" :style="{
            background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
              ? `linear-gradient(135deg, ${prestador.admin.assets.colors.primary}, ${prestador.admin.assets.colors.secondary})`
              : 'linear-gradient(135deg, #3b82f6, #1d4ed8)'
          }">
            <div class="month-info">
              <h3 class="month-title">Vista Mensual</h3>
              <p class="month-subtitle">{{ monthName }} {{ year }}</p>
            </div>
          </div>

          <div class="month-grid">
            <div class="month-weekdays">
              <div v-for="day in ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom']" :key="day" class="weekday-header">
                {{ day }}
              </div>
            </div>

            <div class="month-days">
              <div v-for="n in firstDayOfWeek" :key="'empty-' + n" class="month-day empty-day"></div>

              <div v-for="day in daysInMonth" :key="day" class="month-day" :class="{
                'today': isCurrentDay(day),
                'has-orders': hasOrders(day),
                'weekend': isWeekend(day)
              }" :style="isCurrentDay(day) ? {
                background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                  ? `linear-gradient(135deg, ${prestador.admin.assets.colors.primary}20, ${prestador.admin.assets.colors.secondary}20)`
                  : 'linear-gradient(135deg, #3b82f620, #1d4ed820)'
              } : {}">

                <div class="day-number" :style="isCurrentDay(day) ? {
                  color: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                    ? prestador.admin.assets.colors.primary : '#3b82f6'
                } : {}">{{ day }}</div>

                <!-- Botón para agregar cita en día del mes -->
                <button class="add-appointment-btn-month" @click.stop="openAgendaModalForMonth(day)"
                  v-if="false" :style="{
                    background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                      ? prestador.admin.assets.colors.primary : '#3b82f6'
                  }">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </button>

                <div v-if="hasOrders(day)" class="day-orders" @click.stop="selectDay(day)">
                  <div v-for="order in getOrdersForDay(day)" :key="order.id" class="month-order-card notion-tiny-card"
                    :class="getOrderStatusClass(order)" @click.stop="showOrderDetails(order)"
                    :title="`${formatTime(order.desde)} - ${order.nombre} ${order.apellido1} - ${getServiceName(order)} - Prof. ${getProfessionalName(order)} - ${order.direccion}`">

                    <div class="month-order-time" :style="{
                      color: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
                        ? prestador.admin.assets.colors.primary : '#3b82f6'
                    }">{{ formatTime(order.desde) }}</div>
                    <div class="month-order-professional">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="8.5" cy="7" r="4"></circle>
                        <path d="M20 8v6"></path>
                        <path d="M23 11h-6"></path>
                      </svg>
                      Prof. {{ getProfessionalName(order).substring(0, 1) }}. {{ getProfessionalLastName(order) }}
                    </div>
                  </div>
                </div>

                <div v-else class="no-orders" @click.stop="selectDay(day)">
                  <div class="no-orders-indicator"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal de Agenda -->
        <div v-if="id_prestador == 16 || id_prestador == 23">
          <ModalAgendaWrapper :visible="showAgendaModal" :fechaInicial="fechaPreseleccionada"
            :horaInicial="horaPreseleccionada" @close="showAgendaModal = false" />
        </div>

        <ModalCalendario v-if="selectedOrder" :order="selectedOrder" :prestador="prestador" :comunas="comunas"
          :formatTime="formatTime" :getStatusBadgeClass="getStatusBadgeClass" :getStatusText="getStatusText"
          :getProfessionalName="getProfessionalName" :getProfessionalLastName="getProfessionalLastName"
          :formatCommentDate="formatCommentDate" @close="selectedOrder = null" />


      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import TopNav from '@/components/TopNav.vue';
import ModalCalendario from "@/components/utils/ModalCalendario.vue";
import ModalAgendaWrapper from './utils/ModalAgendaWrapper.vue';

import { mapGetters } from 'vuex';

export default {
  components: {
    SideNav,
    Loader,
    TopNav,
    ModalCalendario,
    // ModalAgendaV2,
    ModalAgendaWrapper
  },
  data() {
    const today = new Date()
    return {
      view: 'week',
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate(),
      selectedDay: today.getDate(),
      currentWeekStart: null,
      allOrders: [],
      orders: [],
      hours: Array.from({ length: 12 }, (_, i) => i + 8),
      extendedHours: Array.from({ length: 16 }, (_, i) => i + 6), // 6 AM to 9 PM
      selectedOrder: null,
      orderModal: null,
      loading: false,
      profesionales: [],
      prestadores: [],
      status: [
        {
          0: "Anulado",
          1: "Citado",
          2: "Confirmado",
          3: "Atendido",
          4: "No Atendido",
        }
      ],
      selectedPrestador: [],
      selectedProfesional: [],
      selectedStatus: [],
      showDropdownPrestador: false,
      showDropdownProfesional: false,
      showDropdownStatus: false,
      profesionalSearch: '',
      showAgendaModal: false,

      fechaPreseleccionada: null,
      horaPreseleccionada: null,
      id_prestador: null,
    }
  },
  computed: {
    ...mapGetters(['prestador', 'comunas', 'prestador_id']),
    monthName() {
      const date = new Date(this.year, this.month - 1, 1)
      return date.toLocaleString('es-ES', { month: 'long' }).toUpperCase()
    },
    daysInMonth() {
      return new Date(this.year, this.month, 0).getDate()
    },
    firstDayOfWeek() {
      const firstDay = new Date(this.year, this.month - 1, 1).getDay()
      return firstDay === 0 ? 6 : firstDay - 1
    },
    weekDays() {
      const days = []
      let startDate

      if (this.view === 'week' && this.currentWeekStart) {
        startDate = new Date(this.currentWeekStart)
      } else {
        const currentDate = new Date(this.year, this.month - 1, this.selectedDay)
        startDate = new Date(currentDate)
        startDate.setDate(currentDate.getDate() - currentDate.getDay() + 1)
      }

      for (let i = 0; i < 7; i++) {
        const day = new Date(startDate)
        day.setDate(startDate.getDate() + i)

        // USAR DIRECTAMENTE sin formatDate
        days.push({
          name: day.toLocaleDateString('es-ES', { weekday: 'short' }),
          date: day.getDate(),
          fullDate: day.toISOString().split('T')[0] // ← CAMBIO IMPORTANTE
        })
      }

      return days
    },
    currentPeriodText() {
      if (this.view === 'day') {
        return this.currentDayText
      } else if (this.view === 'week') {
        return this.currentWeekText
      } else {
        return `${this.monthName} ${this.year}`
      }
    },
    currentDayText() {
      const date = new Date(this.year, this.month - 1, this.day);
      return date.toLocaleDateString('es-ES', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    currentWeekText() {
      if (this.weekDays.length > 0) {
        const firstDay = this.weekDays[0]
        const lastDay = this.weekDays[6]

        // Obtener los meses reales de cada día
        const firstDayMonth = new Date(firstDay.fullDate).getMonth() + 1
        const lastDayMonth = new Date(lastDay.fullDate).getMonth() + 1

        if (firstDayMonth === lastDayMonth) {
          // Mismo mes: "29 - 5 de OCTUBRE 2025"
          const monthName = new Date(firstDay.fullDate).toLocaleString('es-ES', { month: 'long' }).toUpperCase()
          return `${firstDay.date} - ${lastDay.date} de ${monthName} ${this.year}`
        } else {
          // Meses diferentes: "29 sept - 5 oct 2025"
          const firstMonthName = new Date(firstDay.fullDate).toLocaleString('es-ES', { month: 'short' })
          const lastMonthName = new Date(lastDay.fullDate).toLocaleString('es-ES', { month: 'short' })
          return `${firstDay.date} ${firstMonthName} - ${lastDay.date} ${lastMonthName} ${this.year}`
        }
      }
      return 'Semana actual'
    },
    filteredProfesionales() {
      if (!this.profesionalSearch) return this.profesionales;
      return this.profesionales.filter(prof =>
        prof.nombre.toLowerCase().includes(this.profesionalSearch.toLowerCase())
      );
    }
  },
  async mounted() {
    this.id_prestador = this.prestador.id
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === 'orderModal') {
      }
    })
    this.initializeCurrentWeek()
    await this.fetchOrders()
    await this.getProfesionales()
    await this.getPrestadores()
  },
  methods: {
    openAgendaModal(fullDate, hour) {
      console.log('openAgendaModal llamado con:', { fullDate, hour });
      this.fechaPreseleccionada = fullDate;
      this.horaPreseleccionada = hour * 60;
      this.showAgendaModal = true;
      console.log('showAgendaModal cambiado a:', this.showAgendaModal);
    },

    openAgendaModalForMonth(day) {
      console.log('openAgendaModalForMonth llamado con day:', day);
      const fullDate = `${this.year}-${String(this.month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      console.log('Fecha construida:', fullDate);
      this.openAgendaModal(fullDate, 9);
    },

    openAgendaModalForDay(hour) {
      console.log('openAgendaModalForDay llamado con hour:', hour);
      const fullDate = `${this.year}-${String(this.month).padStart(2, '0')}-${String(this.day).padStart(2, '0')}`;
      console.log('Fecha construida:', fullDate);
      this.openAgendaModal(fullDate, hour);
    },

    formatDateForModal(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    handleHoraSeleccionada(ordenData) {
      this.showAgendaModal = false;

      this.$notify({
        group: 'foo',
        title: '¡Hora agendada!',
        text: `Se ha agendado correctamente`,
        type: 'success'
      });

      this.cargarOrdenes();
    },
    initializeCurrentWeek() {
      const today = new Date()
      const startOfWeek = new Date(today)
      startOfWeek.setDate(today.getDate() - today.getDay() + 1)
      this.currentWeekStart = startOfWeek
    },

    async fetchDayOrders(fetchDay, fetchMonth, fetchYear) {
      try {
        const response = await axios.post(window.hostname + '/api/admin/get_ordenes_dia', {
          dia: fetchDay,
          mes: fetchMonth,
          año: fetchYear,
          dia2: fetchDay,
          mes2: fetchMonth,
          año2: fetchYear
        });

        if (response.status !== 200) {
          throw new Error(`API responded with status ${response.status}`);
        }

        return response.data?.ordenes || [];
      } catch (error) {
        console.error('API Error:', {
          request: { fetchDay, fetchMonth, fetchYear },
          error: error.response?.data || error.message
        });
        throw error;
      }
    },

    async fetchWeekOrders(startDate) {
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);

      const fetchDay = startDate.getDate();
      const fetchMonth = startDate.getMonth() + 1;
      const fetchYear = startDate.getFullYear();

      const fetchDay2 = endDate.getDate();
      const fetchMonth2 = endDate.getMonth() + 1;
      const fetchYear2 = endDate.getFullYear();

      const response = await axios.post(window.hostname + '/api/admin/get_ordenes_dia', {
        dia: fetchDay,
        mes: fetchMonth,
        año: fetchYear,
        dia2: fetchDay2,
        mes2: fetchMonth2,
        año2: fetchYear2
      });

      return response.data?.ordenes || [];
    },

    async fetchMonthOrders(fetchMonth, fetchYear) {
      const response = await axios.post(window.hostname + '/api/admin/get_ordenes_mes', {
        mes: fetchMonth,
        año: fetchYear
      });

      return response.data?.ordenes || [];
    },

    async fetchOrders() {
      this.loading = true;
      try {
        this.orders = [];
        let rawOrders = [];

        if (this.view === 'day') {
          rawOrders = await this.fetchDayOrders(this.day, this.month, this.year);
        } else if (this.view === 'week' && this.currentWeekStart) {
          const startDate = new Date(this.currentWeekStart);
          rawOrders = await this.fetchWeekOrders(startDate);
        } else if (this.view === 'month') {
          rawOrders = await this.fetchMonthOrders(this.month, this.year);
        }

        this.allOrders = rawOrders.map(order => {
          order.isoDate = `${order.fecha.a}-${String(order.fecha.m).padStart(2, '0')}-${String(order.fecha.d).padStart(2, '0')}`;
          return order;
        });

        this.applyFilters();
      } catch (e) {
        console.error('Error fetching orders:', e);
        this.allOrders = [];
        this.orders = [];
      } finally {
        this.loading = false;
      }
    },

    getProfesionales() {
      this.loading = true;
      axios({ url: window.hostname + '/api/admin/getprofesionales', method: 'GET' })
        .then((r) => {
          this.loading = false;
          this.profesionales = r.data.profesionales;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        })
    },

    getPrestadores() {
      if (this.prestador.id == 1) {
        this.loading = true;
        axios.get(window.hostname + '/api/admin/get_prestadores')
          .then(r => {

            this.prestadores = r.data.prestadores
            this.loading = false;
          })
          .catch(r => {
            this.loading = false;
          })
      } else {
        console.log('skipped')
      }
    },
    applyFilters() {
      this.orders = this.allOrders.filter(order => {
        const matchesEstado = this.selectedStatus.length
          ? this.selectedStatus.includes(String(order.estado))
          : true;

        const matchesProfesional = this.selectedProfesional.length
          ? this.selectedProfesional.includes(order.profesional_id)
          : true;

        const matchesPrestador = this.selectedPrestador.length
          ? this.selectedPrestador.map(p => p.toLowerCase().trim()).includes(String(order.prestador).toLowerCase().trim())
          : true;

        return matchesEstado && matchesProfesional && matchesPrestador;
      });
    },

    // Utility methods for week view V3
    formatHour(hour) {
      return hour.toString().padStart(2, '0') + ':00'
    },

    getHourPeriod(hour) {
      return hour < 12 ? 'AM' : 'PM'
    },

    getMonthName(dateStr) {
      const [year, month, day] = dateStr.split('-').map(Number)
      const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
      return meses[month - 1] // month ya viene como 1-12
    },

    isCurrentHour(dateStr, hour) {
      const now = new Date()
      const cellDate = new Date(dateStr)

      return cellDate.toDateString() === now.toDateString() &&
        hour === now.getHours()
    },

    isPastHour(dateStr, hour) {
      const now = new Date()
      const cellDate = new Date(dateStr)
      const cellDateTime = new Date(cellDate)
      cellDateTime.setHours(hour, 0, 0, 0)

      return cellDateTime < now
    },

    getAppointmentStyle(order) {
      const duration = order.hasta - order.desde
      const heightMultiplier = duration / 60 // 1 hour = 60 minutes

      return {
        minHeight: `${Math.max(heightMultiplier * 60, 80)}px`
      }
    },

    truncateText(text, maxLength) {
      if (!text) return ''
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
    },

    // Métodos auxiliares para manejar datos faltantes
    getServiceName(order) {
      if (order.examenes && order.examenes.length > 0 && order.examenes[0].nombre) {
        return order.examenes[0].nombre
      }
      return 'Servicio sin especificar'
    },

    getProfessionalName(order) {
      if (order.profesional && order.profesional.nombre) {
        return order.profesional.nombre
      }
      return 'Sin asignar'
    },

    getProfessionalLastName(order) {
      if (order.profesional && order.profesional.apellido) {
        return order.profesional.apellido
      }
      return ''
    },

    changeView(newView) {
      this.view = newView;

      if (newView === 'week') {
        const today = new Date();
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay() + 1);
        this.currentWeekStart = startOfWeek;
      }

      this.fetchOrders();
    },

    navigatePrevious() {
      if (this.view === 'day') {
        const currentDate = new Date(this.year, this.month - 1, this.day);
        currentDate.setDate(currentDate.getDate() - 1);
        this.year = currentDate.getFullYear();
        this.month = currentDate.getMonth() + 1;
        this.day = currentDate.getDate();
        this.selectedDay = this.day;
      } else if (this.view === 'week') {
        if (!this.currentWeekStart) return;
        const newDate = new Date(this.currentWeekStart);
        newDate.setDate(newDate.getDate() - 7);
        this.currentWeekStart = newDate;
        this.year = newDate.getFullYear();
        this.month = newDate.getMonth() + 1;
        this.day = newDate.getDate();
      } else {
        // Para month
        const currentDate = new Date(this.year, this.month - 1, 1);
        currentDate.setMonth(currentDate.getMonth() - 1);
        this.year = currentDate.getFullYear();
        this.month = currentDate.getMonth() + 1;
        this.currentWeekStart = new Date(currentDate);
      }
      this.fetchOrders();
    },
    navigateNext() {
      if (this.view === 'day') {
        const currentDate = new Date(this.year, this.month - 1, this.day);
        currentDate.setDate(currentDate.getDate() + 1);
        this.year = currentDate.getFullYear();
        this.month = currentDate.getMonth() + 1;
        this.day = currentDate.getDate();
        this.selectedDay = this.day;
      } else if (this.view === 'week') {
        if (!this.currentWeekStart) return;
        const newDate = new Date(this.currentWeekStart);
        newDate.setDate(newDate.getDate() + 7);
        this.currentWeekStart = newDate;
        this.year = newDate.getFullYear();
        this.month = newDate.getMonth() + 1;
        this.day = newDate.getDate();
      } else {
        // Para month
        const currentDate = new Date(this.year, this.month - 1, 1);
        currentDate.setMonth(currentDate.getMonth() + 1);
        this.year = currentDate.getFullYear();
        this.month = currentDate.getMonth() + 1;
        this.currentWeekStart = new Date(currentDate);
      }
      this.fetchOrders();
    },

    goToToday() {
      const today = new Date();

      if (this.view === 'day') {
        this.year = today.getFullYear();
        this.month = today.getMonth() + 1;
        this.day = today.getDate();
        this.selectedDay = this.day;
      } else if (this.view === 'week') {
        this.initializeCurrentWeek();
      } else {
        this.year = today.getFullYear();
        this.month = today.getMonth() + 1;
      }

      this.fetchOrders();
    },

    async navigatePreviousDay() {
      const currentDate = new Date(this.year, this.month - 1, this.day);
      currentDate.setDate(currentDate.getDate() - 1);

      // Actualiza todas las variables de fecha
      this.currentDate = new Date(currentDate); // <-- Esta es la clave
      this.year = currentDate.getFullYear();
      this.month = currentDate.getMonth() + 1;
      this.day = currentDate.getDate();

      await this.fetchOrders();
    },

    async navigateNextDay() {
      const currentDate = new Date(this.year, this.month - 1, this.day);
      currentDate.setDate(currentDate.getDate() + 1);

      this.currentDate = new Date(currentDate); // <-- Actualiza currentDate
      this.year = currentDate.getFullYear();
      this.month = currentDate.getMonth() + 1;
      this.day = currentDate.getDate();

      await this.fetchOrders();
    },

    async navigatePreviousWeek() {
      if (!this.currentWeekStart) return;

      const newDate = new Date(this.currentWeekStart);
      newDate.setDate(newDate.getDate() - 7);

      // Actualizar estado interno
      this.currentWeekStart = newDate;
      this.year = newDate.getFullYear();
      this.month = newDate.getMonth() + 1;
      this.day = newDate.getDate();

      // Llamada directa a la API
      const orders = await this.fetchWeekOrders(newDate);
      this.orders = orders.map(order => ({
        ...order,
        isoDate: `${order.fecha.a}-${String(order.fecha.m).padStart(2, '0')}-${String(order.fecha.d).padStart(2, '0')}`
      }));
    },

    async navigateNextWeek() {
      if (!this.currentWeekStart) return;

      const newDate = new Date(this.currentWeekStart);
      newDate.setDate(newDate.getDate() + 7);

      // Actualizar estado interno
      this.currentWeekStart = newDate;
      this.year = newDate.getFullYear();
      this.month = newDate.getMonth() + 1;
      this.day = newDate.getDate();

      // Llamada directa a la API
      const orders = await this.fetchWeekOrders(newDate);
      this.orders = orders.map(order => ({
        ...order,
        isoDate: `${order.fecha.a}-${String(order.fecha.m).padStart(2, '0')}-${String(order.fecha.d).padStart(2, '0')}`
      }));
    },

    formatDate(date) {
      return date.toISOString().split('T')[0]
    },
    formatTime(minutes) {
      const hours = Math.floor(minutes / 60)
      const mins = minutes % 60
      return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`
    },
    formatCommentDate(dateObj) {
      if (!dateObj) return 'Fecha no disponible'
      return `${dateObj.d}/${dateObj.m}/${dateObj.a} ${dateObj.h}:${String(dateObj.min).padStart(2, '0')}`
    },
    getStatusText(statusCode) {
      const statusMap = {
        0: 'Anulado',
        1: 'Citado',
        2: 'Confirmado',
        3: 'Atendido',
        4: 'No Atendido'
      }
      return statusMap[statusCode] || 'Desconocido'
    },
    getStatusBadgeClass(order) {
      return {
        'bg-danger': order.estado === 0,
        'bg-warning': order.estado === 1,
        'bg-primary': order.estado === 2,
        'bg-info': order.estado === 3,
        'bg-success': order.estado === 4
      }
    },
    getOrderStatusClass(order) {
      return {
        'cancelled': order.estado === 0,
        'scheduled': order.estado === 1,
        'confirmed': order.estado === 2,
        'in-progress': order.estado === 3,
        'completed': order.estado === 4
      }
    },
    getOrdersForDay(day) {
      const dateStr = `${this.year}-${String(this.month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
      return this.orders.filter(order => order.isoDate === dateStr)
    },
    getOrdersForDayAndHour(dayDate, hour) {
      const startMinute = hour * 60;
      const endMinute = (hour + 1) * 60;

      // Asegurarnos que dayDate es un objeto Date válido
      const cellDate = typeof dayDate === 'string'
        ? new Date(dayDate + 'T00:00:00') // Si es string YYYY-MM-DD
        : new Date(dayDate); // Si ya es Date

      // Ajustar a inicio del día en UTC para evitar problemas de zona horaria
      const cellDateUTC = new Date(Date.UTC(
        cellDate.getFullYear(),
        cellDate.getMonth(),
        cellDate.getDate()
      ));

      return this.orders.filter(order => {
        // Crear fecha del orden en UTC
        const orderDateUTC = new Date(Date.UTC(
          order.fecha.a,
          order.fecha.m - 1,
          order.fecha.d
        ));

        // Comparar fechas en UTC
        const sameDay = orderDateUTC.getTime() === cellDateUTC.getTime();

        // Comparar el rango de horas
        const hourMatch = (
          (order.desde >= startMinute && order.desde < endMinute) ||
          (order.hasta > startMinute && order.hasta <= endMinute) ||
          (order.desde <= startMinute && order.hasta >= endMinute)
        );

        return sameDay && hourMatch;
      });
    },
    getOrdersForHour(hour) {
      const dateStr = `${this.year}-${String(this.month).padStart(2, '0')}-${String(this.selectedDay).padStart(2, '0')}`;

      return this.orders.filter(order => {
        // Verificar que sea el día correcto
        if (order.isoDate !== dateStr) return false;

        // Convertir la hora a minutos
        const hourStartMinutes = hour * 60;
        const hourEndMinutes = (hour + 1) * 60;

        // Mostrar citas que estén activas durante esta hora
        const overlaps = (
          (order.desde < hourEndMinutes && order.hasta > hourStartMinutes)
        );

        return overlaps;
      });
    },


    getAppointmentPosition(order, currentHour) {
      const hourStartMinutes = currentHour * 60;
      const hourEndMinutes = (currentHour + 1) * 60;

      // Si la cita empieza antes de esta hora, calcular offset
      let top = 0;
      if (order.desde < hourStartMinutes) {
        top = 0;
      } else {
        // Calcular posición basada en minutos dentro de la hora
        top = ((order.desde - hourStartMinutes) / 60) * 100;
      }

      // Calcular altura basada en cuánto de la cita cae en esta hora
      const endInThisHour = Math.min(order.hasta, hourEndMinutes);
      const startInThisHour = Math.max(order.desde, hourStartMinutes);
      const durationInThisHour = endInThisHour - startInThisHour;
      const height = (durationInThisHour / 60) * 100;

      return {
        top: `${top}%`,
        height: `${height}%`,
        position: 'absolute',
        width: 'calc(100% - 8px)',
        left: '4px',
        'z-index': 10
      };
    },



    debugHourOrders(hour) {
      const dateStr = `${this.year}-${String(this.month).padStart(2, '0')}-${String(this.selectedDay).padStart(2, '0')}`;

      const ordersThisHour = this.orders.filter(order => {
        if (order.isoDate !== dateStr) return false;
        const hourStart = hour * 60;
        const hourEnd = (hour + 1) * 60;
        return (order.desde < hourEnd && order.hasta > hourStart);
      });

      ordersThisHour.forEach(order => {
        console.log(`Orden ${order.id}: ${this.formatTime(order.desde)}-${this.formatTime(order.hasta)}`);
      });
    }


    ,


    hasOrders(day) {
      return this.getOrdersForDay(day).length > 0
    },
    isCurrentDay(day) {
      const today = new Date()
      return day === today.getDate() &&
        this.month === today.getMonth() + 1 &&
        this.year === today.getFullYear()
    },
    isToday(dateStr) {
      const today = new Date().toISOString().split('T')[0]
      return dateStr === today
    },
    isWeekend(day) {
      const date = new Date(this.year, this.month - 1, day)
      const dayOfWeek = date.getDay()
      return dayOfWeek === 0 || dayOfWeek === 6
    },
    selectDay(day, month = this.month, year = this.year) {
      this.selectedDay = day;
      this.day = day;
      this.month = month;
      this.year = year;

      if (this.view !== 'day') {
        this.view = 'day';
      }

      this.fetchOrders();
    },
    showDayDetails(dateStr) {
      const day = new Date(dateStr).getDate()
      this.selectDay(day)
    },
    showOrderDetails(order) {
      this.selectedOrder = order;
      // No necesitas $bvModal.show()
    },
    prevMonth() {
      if (this.month === 1) {
        this.month = 12
        this.year--
      } else {
        this.month--
      }
      this.fetchOrders()
    },
    nextMonth() {
      if (this.month === 12) {
        this.month = 1
        this.year++
      } else {
        this.month++
      }
      this.fetchOrders()
    }
  },
  watch: {
    month() {
      if (this.view === 'month') {
        this.selectedDay = 1
      }
    },
    fechaInicial(newVal) {
      if (newVal) {
        const [year, month, day] = newVal.split('-').map(Number);

        this.dayProp = day;
        this.monthProp = month;
        this.yearProp = year;


        this.seleccionarDia(this.dayProp, this.monthProp, this.yearProp);
      }
    }
  }
}
</script>

<style scoped>
/* Base Styles - Notion inspired with medical touches */
.add-appointment-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.week-hour-cell-v3:hover .add-appointment-btn {
  opacity: 1;
}

.add-appointment-btn:hover {
  transform: translate(-50%, -50%) scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Asegurar que el botón no se muestre en celdas con citas existentes */
.hour-appointments:not(:empty)~.add-appointment-btn {
  display: none;
}

/* Ajustar el empty-hour-cell para que no interfiera */
.empty-hour-cell {
  display: none;
}

.column-right {
  background-color: #f8fafc;
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
  transition: all 0.3s ease;
}

.medical-calendar-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #fafbfc 0%, #f4f6f8 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  padding: 2rem;
}

/* Loading State */
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  margin-left: 250px;
  background: linear-gradient(135deg, #fafbfc 0%, #f4f6f8 100%);
}

/* Header Section - Notion Style */
.calendar-header-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.02);
  border: 1px solid #e1e5e9;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.calendar-icon {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.24);
  flex-shrink: 0;
}

.title-text {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.calendar-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  letter-spacing: -0.025em;
  line-height: 1.2;
}

.calendar-subtitle {
  font-size: 1rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.view-controls {
  display: flex;
  gap: 0.25rem;
  background: #f1f5f9;
  padding: 0.25rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.view-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #64748b;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
}

.filter-btn {
  gap: 0.5rem;
  border: none;
  background: transparent;
  color: #64748b;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;

  width: 20%;
  box-sizing: border-box;
}

.dropdown-menu {
  min-width: 300px;
  /* Más ancho */
  max-height: 300px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #1f2937;
  padding: 8px 0;
}

/* Input de búsqueda */
.dropdown-menu input[type="text"] {
  width: 90%;
  margin: 6px auto;
  display: block;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
}

/* Etiquetas de opciones */
.dropdown-menu label {
  display: block;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  border-radius: 4px;
}

.dropdown-menu label:hover {
  background-color: #f3f4f6;
}

.dropdown-menu input[type="checkbox"] {
  margin-right: 8px;
}

.view-btn:hover {
  background: white;
  color: #374151;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.view-btn.active {
  background: white;
  color: #3b82f6;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.navigation-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2rem;
}

.nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 2px solid #e2e8f0;
  background: white;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #64748b;
}

.nav-btn:hover {
  color: #3b82f6;
  background: #f8fafc;
  border-color: #cbd5e1;
}

.current-period {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
  margin: 0;
  min-width: 250px;
  text-align: center;
}

/* Status Legend */
.status-legend {
  background: #f8fafc;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e2e8f0;
}

.legend-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 1rem 0;
}

.legend-items {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #64748b;
}

.add-appointment-btn-month {
  padding: 4px 10px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #e0e0e0;
  background-color: transparent;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.add-appointment-btn-month:hover {
  background-color: #f5f5f5;
  border-color: #d0d0d0;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
}

.legend-color.cancelled {
  background: #ef4444;
}

.legend-color.scheduled {
  background: #f59e0b;
}

.legend-color.confirmed {
  background: #3b82f6;
}

.legend-color.in-progress {
  background: #8b5cf6;
}

.legend-color.completed {
  background: #10b981;
}

/* Notion-style Cards */
.notion-card {
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.notion-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
  border-color: #cbd5e1;
}

.notion-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #3b82f6;
}

.notion-card.cancelled::before {
  background: #ef4444;
}

.notion-card.scheduled::before {
  background: #f59e0b;
}

.notion-card.confirmed::before {
  background: #3b82f6;
}

.notion-card.in-progress::before {
  background: #8b5cf6;
}

.notion-card.completed::before {
  background: #10b981;
}

.notion-mini-card {
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 6px;
  padding: 0.5rem;
  margin-bottom: 0.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.75rem;
  line-height: 1.3;
  position: relative;
  overflow: hidden;
}

.notion-mini-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.notion-mini-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: #3b82f6;
}

.notion-mini-card.cancelled::before {
  background: #ef4444;
}

.notion-mini-card.scheduled::before {
  background: #f59e0b;
}

.notion-mini-card.confirmed::before {
  background: #3b82f6;
}

.notion-mini-card.in-progress::before {
  background: #8b5cf6;
}

.notion-mini-card.completed::before {
  background: #10b981;
}

.notion-tiny-card {
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  margin-bottom: 0.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.65rem;
  line-height: 1.2;
  position: relative;
  overflow: hidden;
}

.notion-tiny-card:hover {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.notion-tiny-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: #3b82f6;
}

.notion-tiny-card.cancelled::before {
  background: #ef4444;
}

.notion-tiny-card.scheduled::before {
  background: #f59e0b;
}

.notion-tiny-card.confirmed::before {
  background: #3b82f6;
}

.notion-tiny-card.in-progress::before {
  background: #8b5cf6;
}

.notion-tiny-card.completed::before {
  background: #10b981;
}

/* Day View */
.day-view {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.02);
  border: 1px solid #e1e5e9;
  display: flex;
  flex-direction: column;
  max-height: 100%;
}

/* Encabezado */
.day-header {
  color: white;
  padding: 2rem;
  position: relative;
  overflow: hidden;
}

.day-header::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.1);
}

.day-info {
  text-align: center;
  position: relative;
  z-index: 1;
}

.day-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem;
  color: white;
}

.day-subtitle {
  font-size: 1rem;
  opacity: 0.9;
  margin: 0;
}

/* Contenedor scrollable */
.timeline-container {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;
}

/* Bloque de hora */
.hour-block {
  display: flex;
  align-items: flex-start;
  gap: 2rem;
  margin-bottom: 2rem;
  min-height: 100px;
  flex-wrap: wrap;
}

/* Indicador de hora */
.hour-indicator {
  display: flex;
  align-items: center;
  gap: 1rem;
  min-width: 80px;
  flex-shrink: 0;
}

.hour-time {
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
}

.hour-line {
  flex: 1;
  height: 1px;
  background: #e2e8f0;
  border-radius: 1px;
}

/* Columna de citas */
.appointments-column {
  flex: 1;
  position: relative;
  min-height: 80px;
}

/* Contenedor para citas de la misma hora */
.same-hour-appointments {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
  width: 100%;
}

/* Tarjeta de cita */
.appointment-card {
  flex: 1;
  min-width: 200px;
  max-width: 300px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.appointment-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Encabezado de cita */
.appointment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.appointment-time {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Contenido de cita */
.appointment-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.patient-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.patient-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.patient-details {
  flex: 1;
}

.patient-name {
  font-weight: 600;
  color: #1a202c;
  font-size: 1.125rem;
  line-height: 1.2;
}

.patient-meta {
  color: #64748b;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.service-info,
.professional-info,
.location-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.service-name,
.professional-name,
.location-text {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
}

.empty-hour {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  background: #f8fafc;
  border: 2px dashed #e2e8f0;
  border-radius: 12px;
  color: #9ca3af;
}

.empty-icon {
  opacity: 0.5;
}

.empty-text {
  font-style: italic;
  font-size: 0.875rem;
}

/* --- Responsividad --- */
@media (max-width: 1024px) {
  .appointment-card {
    max-width: calc(50% - 1rem);
  }
}

@media (max-width: 640px) {
  .same-hour-appointments {
    flex-direction: column;
  }

  .appointment-card {
    max-width: 100%;
    width: 100%;
  }
}

/* Week View V3 - IMPROVED WITH SCROLL */
.week-view-v3 {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.02);
  border: 1px solid #e1e5e9;
  height: calc(100vh - 300px);
  display: flex;
  flex-direction: column;
}

.week-header {
  color: white;
  padding: 1.5rem 2rem;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

.week-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
}

.week-info {
  text-align: center;
  position: relative;
  z-index: 1;
}

.week-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem;
  color: white;
}

.week-subtitle {
  font-size: 1rem;
  opacity: 0.9;
  margin: 0;
}

.week-calendar-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Fixed Header */
.week-fixed-header {
  display: flex;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.week-time-column-header {
  width: 120px;
  padding: 1rem;
  background: #f1f5f9;
  border-right: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #374151;
  flex-shrink: 0;
}

.time-header-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
}

.week-days-header {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  background: #e2e8f0;
}

.week-day-header-cell {
  background: #f8fafc;
  padding: 1rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  min-height: 80px;
  transition: all 0.2s ease;
}

.week-day-header-cell.today {
  color: white;
}

.day-name {
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.day-date {
  font-size: 1.5rem;
  font-weight: 700;
}

.day-month {
  font-size: 0.75rem;
  opacity: 0.8;
  text-transform: uppercase;
}

/* Scrollable Content */
.week-scrollable-content {
  flex: 1;
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
}

.week-time-column {
  width: 120px;
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.week-time-slot-v3 {
  height: 80px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
}

.time-slot-content {
  text-align: center;
}

.hour-number {
  display: block;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  line-height: 1;
}

.hour-period {
  display: block;
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 0.125rem;
}

.week-days-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  background: #e2e8f0;
}

.week-day-column {
  background: white;
  display: flex;
  flex-direction: column;
}

.week-hour-cell-v3 {
  height: 80px;
  border-bottom: 1px solid #e2e8f0;
  padding: 0.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.week-hour-cell-v3:hover {
  background-color: #f8fafc;
}

.week-hour-cell-v3.today {
  background-color: #f0f9ff;
}

.week-hour-cell-v3.current-hour {
  background-color: #dbeafe;
}

.week-hour-cell-v3.past-hour {
  background-color: #f9fafb;
  opacity: 0.7;
}

.current-time-indicator {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  z-index: 5;
}

.hour-appointments {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;

  max-height: 120px;
  /* Altura máxima antes de mostrar scroll */
  overflow-y: auto;
  /* Scroll vertical cuando sea necesario */
  scrollbar-width: thin;
  /* Para navegadores modernos */
  padding-right: 2px;
  /* Espacio para el scroll */
}

/* Personaliza el scroll (opcional) */
.hour-appointments::-webkit-scrollbar {
  width: 4px;
}

.hour-appointments::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

.hour-appointments::-webkit-scrollbar-track {
  background-color: transparent;
}

.week-appointment-v3 {
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 4px;
  padding: 0.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.7rem;
  line-height: 1.2;
  position: relative;
  overflow: hidden;
  min-height: 70px;
  display: flex;
  flex-direction: column;
}

.week-appointment-v3:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
  z-index: 10;
}

.appointment-time-badge {
  position: absolute;
  top: 0.125rem;
  right: 0.125rem;
  background: #3b82f6;
  color: white;
  padding: 0.125rem 0.25rem;
  border-radius: 3px;
  font-size: 0.6rem;
  font-weight: 600;
  line-height: 1;
}

.appointment-content-v3 {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-top: 0.125rem;
}

.appointment-patient,
.appointment-service,
.appointment-professional,
.appointment-location {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.65rem;
  line-height: 1.1;
  color: #7c3aed;
}

.appointment-patient {
  font-weight: 600;
  color: #1a202c;
}

.appointment-service {
  color: #059669;
}

.appointment-professional {
  color: #7c3aed;
}

.appointment-location {
  color: #7c3aed;
}

.appointment-status-indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #3b82f6;
}

.appointment-status-indicator.cancelled {
  background: #ef4444;
}

.appointment-status-indicator.scheduled {
  background: #f59e0b;
}

.appointment-status-indicator.confirmed {
  background: #3b82f6;
}

.appointment-status-indicator.in-progress {
  background: #8b5cf6;
}

.appointment-status-indicator.completed {
  background: #10b981;
}

.empty-hour-cell {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-dot {
  width: 4px;
  height: 4px;
  background: #e2e8f0;
  border-radius: 50%;
}

/* Month View */
.month-view {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.02);
  border: 1px solid #e1e5e9;
}

.month-header {
  color: white;
  padding: 2rem;
  position: relative;
  overflow: hidden;
}

.month-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
}

.month-info {
  text-align: center;
  position: relative;
  z-index: 1;
}

.month-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem;
  color: white;
}

.month-subtitle {
  font-size: 1rem;
  opacity: 0.9;
  margin: 0;
}

.month-grid {
  padding: 2rem;
}

.month-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  margin-bottom: 1px;
  background: #e2e8f0;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.weekday-header {
  padding: 1rem;
  text-align: center;
  font-weight: 600;
  color: #374151;
  background: #f1f5f9;
  font-size: 0.875rem;
}

.month-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  background: #e2e8f0;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}

.month-day {
  min-height: 140px;
  background: white;
  padding: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  display: flex;
  flex-direction: column;
}

.month-day:hover {
  background-color: #f8fafc;
}

.month-day.weekend {
  background-color: #fefce8;
}

.month-day.empty-day {
  background-color: #f1f5f9;
  cursor: default;
}

.month-day.empty-day:hover {
  background-color: #f1f5f9;
}

.day-number {
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  flex-shrink: 0;
}

.day-orders {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  overflow-y: auto;
}

.month-order-time {
  font-weight: 600;
  margin-bottom: 0.125rem;
  font-size: 0.65rem;
}

.month-order-professional {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #10b981;
  font-size: 0.6rem;
  font-weight: 500;
}

.no-orders {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.no-orders-indicator {
  width: 4px;
  height: 4px;
  background: #e2e8f0;
  border-radius: 50%;
}

/* Status Badge Classes */
.bg-danger {
  background-color: #fee2e2;
  color: #991b1b;
}

.bg-warning {
  background-color: #fef3c7;
  color: #92400e;
}

.bg-primary {
  background-color: #dbeafe;
  color: #1e40af;
}

.bg-info {
  background-color: #e0f2fe;
  color: #0c4a6e;
}

.bg-success {
  background-color: #d1fae5;
  color: #065f46;
}

/* Modal Styles - Enhanced */
.modal-content-enhanced {
  padding: 0;
}

.modal-header-enhanced {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.modal-title-section {
  flex: 1;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 0.25rem;
}

.modal-subtitle {
  color: #64748b;
  margin: 0;
  font-size: 0.875rem;
}

.status-badge-large {
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.modal-body-enhanced {
  padding: 2rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.info-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.2s ease;
}

.info-section:hover {
  border-color: #cbd5e1;
}

.info-section.full-width {
  grid-column: 1 / -1;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 1rem;
}

.info-items {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e2e8f0;
  gap: 1rem;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 500;
  color: #64748b;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.info-value {
  font-weight: 600;
  color: #1a202c;
  text-align: right;
  word-break: break-word;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 0.75rem;
}

.service-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.service-item:hover {
  border-color: #cbd5e1;
}

.service-icon {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.service-name {
  font-weight: 500;
  color: #1a202c;
  font-size: 0.875rem;
}

.comments-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.comment-item {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  transition: all 0.2s ease;
}

.comment-item:hover {
  border-color: #cbd5e1;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.comment-author {
  font-weight: 600;
  color: #1a202c;
  font-size: 0.875rem;
}

.comment-date {
  font-size: 0.75rem;
  color: #64748b;
}

.comment-text {
  color: #374151;
  margin: 0;
  line-height: 1.5;
  font-size: 0.875rem;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .column-right {
    padding-left: 0px;
  }

  .medical-calendar-container {
    padding: 1rem;
  }

  .calendar-header-section {
    padding: 1.5rem;
  }

  .header-content {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .calendar-icon {
    width: 56px;
    height: 56px;
  }

  .calendar-title {
    font-size: 1.75rem;
  }

  .view-controls {
    width: 100%;
    justify-content: center;
  }

  .navigation-section {
    gap: 1rem;
  }

  .current-period {
    min-width: 200px;
    font-size: 1.25rem;
  }

  .legend-items {
    justify-content: center;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .week-time-column-header,
  .week-time-column {
    width: 100px;
  }
}

@media (max-width: 768px) {
  .medical-calendar-container {
    padding: 0.5rem;
  }

  .calendar-header-section {
    padding: 1rem;
  }

  .calendar-title {
    font-size: 1.5rem;
  }

  .calendar-subtitle {
    font-size: 0.875rem;
  }

  .view-controls {
    flex-direction: column;
    gap: 0.5rem;
  }

  .view-btn {
    justify-content: center;
  }

  .current-period {
    font-size: 1.125rem;
    min-width: 180px;
  }

  .legend-items {
    flex-direction: column;
    gap: 0.75rem;
  }

  .hour-block {
    flex-direction: column;
    gap: 1rem;
  }

  .hour-indicator {
    justify-content: center;
  }

  .appointment-card {
    margin-left: 0;
  }

  .week-view-v3 {
    height: calc(100vh - 250px);
  }

  .week-time-column-header,
  .week-time-column {
    width: 80px;
  }

  .week-day-header-cell {
    padding: 0.75rem 0.5rem;
    min-height: 70px;
  }

  .day-date {
    font-size: 1.25rem;
  }

  .week-time-slot-v3 {
    height: 70px;
  }

  .week-hour-cell-v3 {
    height: 70px;
  }

  .week-appointment-v3 {
    min-height: 60px;
  }

  .month-day {
    min-height: 100px;
    padding: 0.5rem;
  }

  .day-orders {
    gap: 0.125rem;
  }

  .modal-header-enhanced {
    padding: 1rem 1.5rem;
  }

  .modal-body-enhanced {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .medical-calendar-container {
    padding: 0.25rem;
  }

  .calendar-header-section {
    padding: 0.75rem;
  }

  .title-section {
    gap: 0.75rem;
  }

  .calendar-icon {
    width: 48px;
    height: 48px;
  }

  .calendar-title {
    font-size: 1.25rem;
  }

  .current-period {
    font-size: 1rem;
    min-width: 150px;
  }

  .day-header,
  .week-header,
  .month-header {
    padding: 1rem;
  }

  .timeline-container {
    padding: 1rem;
  }

  .appointment-card {
    padding: 1rem;
  }

  .patient-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .week-view-v3 {
    height: calc(100vh - 200px);
  }

  .week-time-column-header,
  .week-time-column {
    width: 70px;
  }

  .week-day-header-cell {
    padding: 0.5rem 0.25rem;
    min-height: 60px;
  }

  .day-name {
    font-size: 0.7rem;
  }

  .day-date {
    font-size: 1rem;
  }

  .day-month {
    font-size: 0.65rem;
  }

  .week-time-slot-v3 {
    height: 60px;
    padding: 0.25rem;
  }

  .hour-number {
    font-size: 0.75rem;
  }

  .hour-period {
    font-size: 0.65rem;
  }

  .week-hour-cell-v3 {
    height: 60px;
    padding: 0.125rem;
  }

  .week-appointment-v3 {
    min-height: 50px;
    padding: 0.125rem;
  }

  .appointment-time-badge {
    font-size: 0.55rem;
    padding: 0.1rem 0.2rem;
  }

  .appointment-patient,
  .appointment-service,
  .appointment-professional,
  .appointment-location {
    font-size: 0.6rem;
  }

  .month-day {
    min-height: 80px;
    padding: 0.25rem;
  }

  .day-number {
    font-size: 0.875rem;
  }

  .modal-header-enhanced {
    padding: 0.75rem 1rem;
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }

  .modal-body-enhanced {
    padding: 1rem;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .info-value {
    text-align: left;
  }
}

/* Scrollbar Styling */
.week-scrollable-content::-webkit-scrollbar {
  width: 8px;
}

.week-scrollable-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.week-scrollable-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.week-scrollable-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.day-orders::-webkit-scrollbar {
  width: 4px;
}

.day-orders::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 2px;
}

.day-orders::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.day-orders::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Animation for smooth transitions */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.week-appointment-v3 {
  animation: fadeInUp 0.3s ease-out;
}

/* Focus states for accessibility */
.week-hour-cell-v3:focus,
.month-day:focus,
.appointment-card:focus,
.week-appointment-v3:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Print styles */
@media print {

  .calendar-header-section,
  .navigation-section {
    display: none;
  }

  .week-view-v3,
  .day-view,
  .month-view {
    height: auto;
    box-shadow: none;
    border: 1px solid #000;
  }

  .week-scrollable-content {
    overflow: visible;
  }
}
</style>